import { gql } from '@apollo/client';

export const GET_FANTASY_LEAGUE_MEMBER_PLAYERS = gql`
  query GetFantasyLeagueMemberPlayers($fantasyLeagueMemberId: ID!) {
    fantasyLeagueMemberPlayers(fantasyLeagueMemberId: $fantasyLeagueMemberId) {
      tactics
      fantasyTeamPlayers {
        id
        createdAt
        startingPosition
        individuallyProtected
        weeklyWindowProtected
        releaseClausePayable
        player {
          id
          createdAt
          nick
          name
          lastName
          role
          marketValue
          image
          totalScore
          lastWeekNumber
          lastWeekScore
          team {
            id
            competition {
              id
              code
              displayName
              rank
            }
            createdAt
            nameShow
            shortName
            shield
          }
        }
      }
    }
  }
`;
